module.exports = __webpack_public_path__ + "static/media/account.6846de83.png";